import { USERDETAILS } from "./actions";
import { ADMINDETAILS } from "./actions";


export  const userdetails=(parameter)=>{
    return {
        type:USERDETAILS,
        payload:parameter
    }
}




export  const admindetails=(parameter)=>{
    return {
        type:ADMINDETAILS,
        payload:parameter
    }
}


